import API from '../http/API';
import { useLogEntry, useRequestUrl, useAuthToken } from '../context/contextHooks';

export const useFinalizeLogEntry = () => {
    const [logEntry, setLogEntry] = useLogEntry();
    const [requestUrl] = useRequestUrl();
    const [authToken] = useAuthToken();

    return (paymentResponse, court, setActionResponse) => {
        if (!logEntry) return;
        const entry = JSON.parse(JSON.stringify(logEntry));
        entry.transactionId = paymentResponse.transactionId;
        if (court) entry.courtId = court.courtId;
        if (paymentResponse.declineMessage) {
            entry.paymentDeclined = true;
            entry.declinedReason = paymentResponse.declineMessage;
            entry.outcome = 'Payment Declined';
            setLogEntry(entry);
        } else {
            const url = `${requestUrl}/saveFinishedLogEntry`;
            API.postRetrieve(url, JSON.stringify(entry), 'saveEntry', `Bearer ${authToken}`, setActionResponse);
            setLogEntry(null);
        }
    };
};
